import { Type } from "lucide-react";

import RHFInput from "@/components/form/RHFInput";
// Color configuration is disabled — it was reskinning the live app (buttons/
// accents) in ways that weren't wanted. Commented out instead of deleted so
// it can be re-enabled later. See BrandingProvider.jsx for the matching
// disabled CSS-var application.
// import ColorPicker from "@/components/ui/ColorPicker";
import { BRANDING_SHELL, BRANDING_SHELL_STYLE, BRANDING_CARD_PADDING } from "../branding.tokens";
import { BRANDING_DISPLAY_NAME_MAX_LENGTH } from "../constants";
import BrandingActionButton from "./BrandingActionButton";
import BrandingSectionHeader from "./BrandingSectionHeader";

const BrandingForm = ({
  disabled,
  canSave,
  hasDraftTextChange,
  isSaving,
  isDiscarding,
  onSave,
  onDiscardChanges,
  onDiscardDraft,
}) => {
  // Three states for this card's own action row, never more than one shown
  // at once:
  //  - typing right now (canSave): Discard Changes (revert the two fields,
  //    no API call) beside Save Draft.
  //  - nothing typed, but the saved draft's text still differs from
  //    published (hasDraftTextChange): Discard Draft — the real backend
  //    action. Gated on the actual text diff, not just "a draft row
  //    exists" — discardDraftConfig() reverts the draft's text without
  //    deleting the row, so right after using it a draft row can still
  //    exist with nothing left in it worth discarding.
  //  - neither: nothing to undo.
  const showUnsavedActions = canSave;
  const showSavedDraftActions = !canSave && hasDraftTextChange;

  return (
    <div className={`${BRANDING_SHELL} ${BRANDING_CARD_PADDING}`} style={BRANDING_SHELL_STYLE}>
      <BrandingSectionHeader icon={Type} title="Draft Branding" subtitle="Tenant name." />

      <div className="grid grid-cols-1 gap-x-3 gap-y-3 md:grid-cols-2">
        <div className="md:col-span-2">
          <RHFInput
            name="displayName"
            label="Display Name"
            placeholder="Enter display name"
            disabled={disabled}
            required
            inputClass="bg-background-secondary"
            maxLength={BRANDING_DISPLAY_NAME_MAX_LENGTH}
            maxLengthMessage={`Display name must be ${BRANDING_DISPLAY_NAME_MAX_LENGTH} characters or less`}
          />
        </div>
        {/*
        <ColorPicker name="primaryColor" label="Primary Color" disabled={disabled} variant="primary" />
        <ColorPicker
          name="primaryColorContrast"
          label="Primary Contrast"
          disabled={disabled}
          variant="contrast"
          pairWith="primaryColor"
        />
        <ColorPicker name="primaryColorDark" label="Primary Color Dark" disabled={disabled} variant="primary" />
        <ColorPicker
          name="primaryColorContrastDark"
          label="Primary Contrast Dark"
          disabled={disabled}
          variant="contrast"
          pairWith="primaryColorDark"
        />
        */}
      </div>

      {(showUnsavedActions || showSavedDraftActions) && (
        <div className="flex items-center justify-end gap-1.5 mt-3">
          {showUnsavedActions && (
            <>
              <BrandingActionButton variant="tertiary" onClick={onDiscardChanges} disabled={disabled || isSaving}>
                Discard Changes
              </BrandingActionButton>
              <BrandingActionButton variant="default" onClick={onSave} disabled={disabled} loading={isSaving} loadingText="Saving...">
                Save Draft
              </BrandingActionButton>
            </>
          )}
          {showSavedDraftActions && (
            <BrandingActionButton variant="destructive" onClick={onDiscardDraft} disabled={disabled} loading={isDiscarding} loadingText="Discarding...">
              Discard Draft
            </BrandingActionButton>
          )}
        </div>
      )}
    </div>
  );
};

export default BrandingForm;
